export default "{\n    \"todayLabel\": \"Hoy\"\n}\n"